// Mock data for TradeEngine.AI website

export const features = [
  {
    id: 1,
    icon: "Layers",
    title: "Unified Core Platform",
    description: "One secure, auditable core that unifies trade execution, inventory, risk, financing, accounting, and operational visibility."
  },
  {
    id: 2,
    icon: "Zap",
    title: "No-Code Automation",
    description: "Build and modify workflows without writing code. Automate decisions with embedded AI that learns from your operations."
  },
  {
    id: 3,
    icon: "BarChart3",
    title: "Real-Time Intelligence",
    description: "Live dashboards and customizable reports give you instant visibility across all operations and departments."
  },
  {
    id: 4,
    icon: "Shield",
    title: "Enterprise Security",
    description: "Built-in compliance, automated audit trails, and role-based access control keep your data protected."
  },
  {
    id: 5,
    icon: "Plug",
    title: "Seamless Integration",
    description: "Eliminate brittle point-to-point integrations. Connect all your systems into one cohesive ecosystem."
  },
  {
    id: 6,
    icon: "Wallet",
    title: "Integrated Neobanking",
    description: "Payments, FX, AR/AP financing, and cash management built directly into your operational workflow."
  }
];

export const useCases = [
  {
    id: 1,
    icon: "Calculator",
    title: "Accounting",
    description: "Automated reconciliation, real-time financial reporting, and seamless GL integration.",
    benefits: ["Automated journal entries", "Real-time P&L", "Multi-currency support"]
  },
  {
    id: 2,
    icon: "TrendingUp",
    title: "Trade Tech",
    description: "End-to-end trade lifecycle management from execution to settlement.",
    benefits: ["Trade capture", "Position management", "Settlement automation"]
  },
  {
    id: 3,
    icon: "Landmark",
    title: "Trade Finance",
    description: "Streamlined financing workflows for letters of credit, guarantees, and working capital.",
    benefits: ["LC management", "Document handling", "Financing requests"]
  },
  {
    id: 4,
    icon: "ClipboardCheck",
    title: "Audit & Compliance",
    description: "Complete audit trails, regulatory reporting, and compliance monitoring.",
    benefits: ["Automated audit logs", "Regulatory reports", "Compliance dashboards"]
  },
  {
    id: 5,
    icon: "ShieldAlert",
    title: "Risk Management",
    description: "Real-time risk monitoring, exposure tracking, and limit management.",
    benefits: ["Risk dashboards", "Limit monitoring", "Alert systems"]
  },
  {
    id: 6,
    icon: "Truck",
    title: "Logistics",
    description: "Track shipments, manage carriers, and optimize your supply chain.",
    benefits: ["Shipment tracking", "Carrier management", "Route optimization"]
  },
  {
    id: 7,
    icon: "Package",
    title: "Inventory",
    description: "Real-time inventory visibility, automated reordering, and warehouse management.",
    benefits: ["Stock tracking", "Auto-reorder", "Warehouse ops"]
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "TradeEngine.AI reduced our reporting time by 80%. What used to take days now takes hours.",
    author: "Tan Wei Lin",
    role: "Head of Trading Operations"
    // company: "Trafigura Asia"
  },
  {
    id: 2,
    quote: "The compliance features are outstanding. We passed our last audit with flying colors.",
    author: "Rajesh Krishnan",
    role: "Chief Risk Officer"
    // company: "Olam International"
  },
  {
    id: 3,
    quote: "Finally, a platform that doesn't require a team of developers to maintain. Game changer.",
    author: "Lim Chee Keong",
    role: "Director of Operations"
    // company: "Wilmar Trading"
  }
];

export const spineFeatures = [
  {
    id: 1,
    title: "Single Source of Truth",
    description: "All your operational data flows through one auditable core, eliminating data silos and reconciliation nightmares."
  },
  {
    id: 2,
    title: "Organic Transformation",
    description: "Evolve digitally without ripping out existing processes. TradeEngine.AI adapts to you, not the other way around."
  },
  {
    id: 3,
    title: "AI-Native Architecture",
    description: "Embedded AI automates decisions, surfaces insights, and learns from your operations continuously."
  },
  {
    id: 4,
    title: "Real-Time Clarity",
    description: "Instant visibility across all operations. No more waiting for end-of-day reports or manual consolidation."
  }
];

export const stats = [
  { value: "80%", label: "Faster Reporting" },
  { value: "Days", label: "Not Months to Go Live" },
  { value: "100%", label: "Audit Trail Coverage" },
  { value: "24/7", label: "Real-Time Visibility" }
];

export const navLinks = [
  { label: "Features", href: "#features" },
  { label: "Solutions", href: "#solutions" },
  { label: "Industries", href: "/industries", isRoute: true },
  { label: "How It Works", href: "#how-it-works" },
  { label: "About", href: "#about" }
];
